import React, { useState, useEffect } from "react";
import {isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { useFetch } from "../../api/FetchApiData";
import { useTranslation } from "react-i18next";
if (isMobile)
    import('./orders_mob.css').then(() => {});
else
    import('./orders.css').then(() => {});

const ORDER_LIST_STATUS = ['En attente','Confirmée', 'Annulée', 'Terminée']

export default function UserOrders({User,setUser})
{
    const [orders,setOrders] = useState([]);
    const navigator = useNavigate();
    const {t} = useTranslation();
    const fetchData = useFetch();

    useEffect(()=>{
        let user_id = User.id;
        if(user_id === undefined || user_id === null)
            user_id = 'self';
        fetchData.GetData(`user/order/${user_id}/all/1/`).then(result=>{
            if(result.result)
                setOrders([...result.orders]);
        });
    },[User]);

    const _status = (status)=>{
        if(typeof(status)===typeof('status'))
            return status
        else
            return status.status
    }

    const Status = (order)=>{
        let status = order.status;
        if(_status(order.status)===ORDER_LIST_STATUS[0])
        {status = t('order.attente');}
        else if(_status(order.status)===ORDER_LIST_STATUS[1])
        {status = t('order.confirme');}
        else if(_status(order.status)===ORDER_LIST_STATUS[3])
        {status = t('ajout-produit.annuler');}
        else if(_status(order.status)===ORDER_LIST_STATUS[4])
        {status = t('Terminer');}
        else
        {status = "Status";}
        return status;
    }

    
    const ShowOrders=()=>
    {        
        if(orders.length===0)
        {
            return(
                <tr><td colSpan={4}>{t('orders.no-order')}</td></tr>
            );
        }
        else
        {
            return(
                orders.slice().reverse().map((order)=>{
                    let color_status = 'black';
                    if(order.status == 'livrée')
                        color_status = 'green';
                    else if(order.status == 'expediée')
                        color_status = 'blue';
                    let color_payment = 'green';
                    if(order.remained_price>0)
                        color_payment = 'red';
                return (
                    <tr onClick={e=>{navigator(`/order/object/${order.id}`)}} key={orders.indexOf(order)}>
                        <td colSpan={1} className="orders-history-td" style={{borderBottom:'1px solid lightgray'}} >
                            {order.order_number}<br/>
                            <label style={{color:'gray',fontSize:'x-small'}}>{order.date.split('T')[0]}</label>
                        </td>
                        <td colSpan={1} className="orders-history-td" onClick={(e)=>{}} style={{borderBottom:'1px solid lightgray',fontWeight:'bold',color:color_payment}}>{t('order.reste')}<span dir="ltr" style={{fontWeight:'bold'}}> : {order.remained_price} €</span></td>
                        <td colSpan={1} className="orders-history-td" onClick={(e)=>{}} style={{borderBottom:'1px solid lightgray',fontWeight:'bold',color:color_status}}>{Status(order).toUpperCase()}</td>
                    </tr>
                )
            }));
        }
        
    }

    return(
        <div id="orders-history">
                <table className="orders-history-table">
                    <thead>
                        <tr style={{backgroundColor:'goldenrod'}}>
                            <th className="orders-history-td" style={{borderTopLeftRadius:'5px'}}>{t('orders.numero')}</th>
                            <th className="orders-history-td" style={{}}>{t('panier.paiement')}</th>
                            <th className="orders-history-td" style={{borderTopRightRadius:'5px'}}>{t('sales.status')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ShowOrders()}
                    </tbody>     
                </table>    
        </div>
    );
}